import React from 'react';

function ServicesAbout() {
    return (
        <>
            <section className="appie-services-2-area bg-light pt-90 pb-55" id="service">
                <div className="container">
                    <div className="row align-items-end">
                        <div className="col-lg-6 col-md-8">
                            <div className="appie-section-title">
                                <h3 className="appie-title">Features</h3>
                                <p>
                                    Here are some of the key features and benefits of using our
                                    backoffice software:
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-file-invoice-dollar"></i>
                                </div>
                                <h4 className="title">Invoice Management</h4>
                                <p>
                                    Create and send invoices in just a few clicks. You can also
                                    customize your invoices with your company logo and other
                                    relevant information to give them a professional look.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-2 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="400ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-file-invoice"></i>
                                </div>
                                <h4 className="title">Proforma</h4>
                                <p>
                                    Easily create professional proforma templates, customize them to
                                    your specific needs, and send them to your clients in just a few
                                    clicks.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-3 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="600ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-folders"></i>
                                </div>
                                <h4 className="title">Account Receivable</h4>
                                <p>
                                    Keep track of your outstanding invoices and follow up with
                                    clients who have not yet paid.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-4 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-money-check"></i>
                                </div>
                                <h4 className="title">Account Payable</h4>
                                <p>
                                    Keep track of your bills and payments to vendors or suppliers.
                                    This helps you prioritize your payments and avoid late fees or
                                    penalties.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-5 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="400ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-cash-register"></i>
                                </div>
                                <h4 className="title">Cashbooks</h4>
                                <p>
                                    Record your income and expenses, and track your cash balance in
                                    real-time. This will help you manage your finances and stay on
                                    top of your cash flow.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-6 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="600ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-file-chart-line"></i>
                                </div>
                                <h4 className="title">Reports</h4>
                                <p>
                                    Generate reports that combines all of the data from our invoice
                                    management, account receivable, account payable, and cashbook
                                    apps.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ServicesAbout;
